var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconCone = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 44,
  height: 44
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#525254",
  fillRule: "evenodd",
  d: "M20.475 2.2c-2.181 0-4.263 1.213-5.002 3.356l-.004.004L3.682 37.4H0v4.4h44v-4.4h-3.682L28.527 5.556c-.739-2.143-2.82-3.356-5.002-3.356zm0 4.4h3.05c.523 0 .818.316.843.387l.008.026 3.107 8.387H16.517l3.107-8.387.008-.026c.025-.071.32-.387.843-.387m-5.586 13.2H29.11l2.445 6.6H12.444zm-4.074 11h22.37l2.445 6.6H8.37z"
})));
export default SvgIconCone;